import { render } from "./EditTourForm.vue?vue&type=template&id=12260596"
import script from "./EditTourForm.vue?vue&type=script&lang=js"
export * from "./EditTourForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "12260596"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12260596', script)) {
    api.reload('12260596', script)
  }
  
  module.hot.accept("./EditTourForm.vue?vue&type=template&id=12260596", () => {
    api.rerender('12260596', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/EditTourForm.vue"

export default script